<script>
import {
    ArrowUpIcon,
    ArrowRightIcon
} from 'vue-feather-icons';

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

/**
 * Page-privacy component
 */
export default {
    data() {
        return {}
    },
    components: {
        Navbar,
        Footer,
        ArrowUpIcon,
        ArrowRightIcon
    }
}
</script>

<template>
<div>
    <Navbar />

    <!-- Hero Start -->
    <section class="bg-half bg-light d-table w-100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12 text-center">
                    <div class="page-next-level">
                        <h4 class="title"> {{$t('privacy.title')}} </h4>
                        <ul class="list-unstyled mt-4">
                            <li class="list-inline-item h6 date text-muted"> {{$t('privacy.time')}}</li>
                        </ul>
                    </div>
                </div>
                <!--end col-->
            </div>
            <!--end row-->
        </div>
        <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <!-- Shape Start -->
    <div class="position-relative">
        <div class="shape overflow-hidden text-white">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
            </svg>
        </div>
    </div>
    <!--Shape End-->

    <!-- Start Privacy -->
    <section class="section">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-9">
                    <div class="card shadow rounded border-0">
                        <div class="card-body">
                          <p>北京灵动无线网络科技有限公司（下称“我们”或“公司”）尊重并保护用户隐私，在您使用Design Mirror产品（以下简称“本产品”）提供的服务时，我们除了按照《服务协议》的约定向您提供服务外，我们还将按照《隐私政策》（以下简称“本隐私政策”）遵循合法、正当、必要的原则，公开明示收集、使用您的个人信息。</p>
                          <p>请您仔细阅读本隐私政策的全部条款以便您了解本产品收集、使用您个人信息的目的、范围、方式等。如果您为儿童，则您应在法定监护人陪同下审阅本隐私政策，经法定监护人审阅并同意后，您方可使用本产品并向本产品提供个人信息。<strong>如果您或监护人不同意本隐私政策任何内容，您应立即停止使用本产品产品或服务。当您使用本产品提供的任一服务时，即表示您已同意我们按照本隐私政策来收集、使用、存储和保护您的相关信息。</strong></p>
                          <p>我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，<strong>我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</strong></p>

                          <p><strong>本隐私政策将帮您了解以下内容：</strong></p>
                          <ul>
                            <li>一、适用范围,</li>
                            <li>二、我们如何收集和使用您的个人信息</li>
                            <li>三、我们如何使用 Cookie 和同类技术</li>
                            <li>四、我们如何共享、转让、公开披露您的个人信息</li>
                            <li>五、您如何管理自己的信息及账号注销</li>
                            <li>六、我们如何存储您的个人信息</li>
                            <li>七、我们如何保护您的个人信息</li>
                            <li>八、我们如何处理儿童的个人信息</li>
                            <li>九、本政策的修订</li>
                            <li>十、争议管辖</li>
                            <li>十一、联系我们</li>
                          </ul>

                          <h3>一、适用范围</h3>
                          <p>1.	本隐私政策适用于除某些特定产品和服务外本产品提供的所有服务。这些特定产品和服务将适用特定的隐私政策。</p>
                          <p>2.	需要特别说明的是，本隐私政策也不适用于除本隐私政策第四条约定经您确认的与第三方共享信息外其他第三方向您提供的服务。请您知悉：如果您浏览第三方网站或使用第三方产品、服务时向其提供个人信息，则您的信息应当使用该第三方的隐私政策，我们不承担任何法律责任，请您届时务必仔细阅读该第三方的隐私政策并确认是否接受。</p>

                          <h3>二、我们如何收集和使用您的个人信息</h3>
                          <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。14 岁以下（含）儿童的个人信息属于个人敏感信息。</p>
                          <p>我们提供的产品和服务需要依赖您的部分信息才得以运行，因此在您使用本产品的时候，需要向我们提供或允许我们收集的必要信息以供我们使用这些信息向您提供基本服务，包括： </p>
                          <h4>1.	您主动提供给我们的信息</h4>
                          <p>(1)	帮助您成为我们的用户，您填写的注册信息，包括您邮箱账号，以用于注册、登录本产品账户使用本产品产品和服务，及我们的客服和售后为您提供咨询服务，并保障您的账户安全。如不提供，您将仅能浏览、了解本产品，无法享受相关服务；如果您仅需使用浏览、了解本产品等，您不需要注册成为我们的用户及提供上述信息；</p>
                          <p>(2)	便于我们向您提供服务，您填写的个人资料，包括您的<strong>头像、昵称、性别、出生年月</strong>，以用于产品个人信息想展示；</p>
                          <p>(3)	当您与我们联系时，我们可能会保存您的通信或通话记录和内容或您留下的联系方式，以便帮助您解决问题，或记录相关问题的处理方案及结果。我们的客服会使用您的帐号信息与您核验您的身份。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息。如不提供，不会影响您使用本产品的其他功能和服务。</p>
                          <h4>2.	我们在您使用服务过程中收集的信息，除法律规定情形外我们都将事先征得您的同意：</h4>
                          <p>(1)	在您首次使用打开本产品app时，我们将在取得您的授权后，接收并记录您所使用的设备相关信息，包括<strong>设备属性信息（IMEI、IMSI、设备型号、操作系统版本、设备设置、唯一设备标识符软硬件特征信息）、设备连接信息（IP地址、电信运营商、访问日期和时间）</strong>，以保障您的账户及交易安全；</p>
                          <p>(2)	在您首次使用打开本产品APP时，我们将在您授权后读取您的读取手机状态，用以保障本产品APP应用服务的正常使用，更准确定位和解决在使用时遇到的问题，改进及优化本产品APP服务体验，以及保障您的账号安全；</p>
                          <p>(3)	在您首次使用打开本产品app（根据您的设备系统不同可能会有场景差异）时，我们将申请您的存储权限，以用于下载课程文件或缓存信息到手机；</p>
                          <p>(4)	在您首次使用扫码登录时候，我们将申请获取您的相机权限，以用于进行二维码扫描。</p>
                          <p>(5)	当您需要保存图片到手机时，我们会申请获取您的相册权限，以实现相应的要求。</p>
                          <p>(6)	当您将本产品app退到后台时，app会在一段时间内仍然保持运行，此时依然有可能会收集设备相关信息（如ANDROID ID，系统版本信息等），这些信息主要用于定位和解决使用中遇到的问题。</p>
                            <p>(7)	当涉及到内容输入时，app会读取您剪切板的数据，以方便您进行复制粘贴。</p>
                          <h4>3.	事先征得同意的例外：</h4>
                          <p>(1)	与个人信息控制者履行法律法规规定的义务相关的；</p>
                          <p>(2)	与国家安全、国防安全直接相关的；</p>
                          <p>(3)	与公共安全、公共卫生、重大公共利益直接相关的；</p>
                          <p>(4)	与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
                          <p>(5)	出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
                          <p>(6)	所涉及的个人信息是个人信息主体自行向社会公众公开的；</p>
                          <p>(7)	根据个人信息主体要求签订和履行合同所必需的；</p>
                          <p>(8)	从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
                          <p>(9)	维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；</p>
                          <p>(10)	个人信息控制者为新闻单位，且其开展合法的新闻报道所必需的。</p>
                          <h4>4.	匿名化处理</h4>
                          <p>对于我们收集到的您的信息，我们将通过技术手段及时进行匿名化处理。在不泄露您个人信息的前提下，我们有权对匿名化处理后的用户数据进行分析、挖掘和利用，有权对本产品产品的使用情况进行统计分析并用于可能的第三方信息共享。</p>


                          <h3>三、我们如何使用 Cookie 和同类技术</h3>
                          <p>我们或我们的第三方合作伙伴，可能通过cookies和web beacon收集和使用您的信息，并将该等信息储存为日志信息。我们使用自己的cookies和web beacon，目的是为您提供账号相关功能，并用于以下用途：</p>
                          <p>1.	记住您的身份。例如：cookies和web beacon有助于我们辨认您作为我们的注册用户的身份。</p>
                          <p>2.	分析您使用我们服务的情况。例如，我们可利用cookies和web beacon来了解您使用我们的服务进行什么活动。</p>
                          <p>我们为上述目的使用cookies和web beacon的同时，可能将通过cookies和web beacon收集的非个人身份信息，经统计加工后提供给其他合作伙伴，用于分析用户如何使用我们的服务。</p>
                          <p>我们的产品和服务上可能会有其他合作方放置的cookies和web beacon。这些cookies和web beacon可能会收集与您相关的非个人身份信息，以用于分析您如何使用该等产品或服务。这些第三方cookies和web beacon收集和使用该等信息，不受本隐私政策约束，而是受相关第三方的隐私政策约束，我们不对此类cookies和web beacon承担责任。</p>
                          <p>您可以通过浏览器设置拒绝或管理cookies。<strong>但请注意，如果停用cookies或web beacon，您有可能无法享受最佳的服务体验，某些产品或服务可能也无法正常使用。</strong></p>


                          <h3>四、我们如何共享、转让、公开披露您的个人信息</h3>
                          <p>1.	我们会以高度的勤勉义务对待您的信息，除非获得您的明确同意，我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，但经过处理无法识别特定个人且不能复原的除外。</p>
                          <p>(1) 本产品app集成友盟同欣（北京）科技有限公司的统计SDK，用于基础数据统计，便于提供更好的服务体验，该服务 收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM 卡 IMSI 信息等），具体详见<a href="https://www.umeng.com/page/policy">《隐私权政策》</a></p>
                          <p>(2) 本产品app集成腾讯开放平台SDK，用户提供分享到微信、QQ的功能，该服务 收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM 卡 IMSI 信息等），具体详见<a href="https://privacy.qq.com/policy/tencent-privacypolicy">《腾讯隐私保护平台》</a></p>
                          <p><strong>我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理信息，信息接收方对您的信息仅有有限的访问权，他们还需承担合同义务，包括不限于使用合法合规的方式获取您的信息，采取合理的安全措施保护您的信息，根据法律规定及与我们的约定承担相应的法律责任。对于一些开源、免费的合作方出现如果出现泄露您的信息等侵犯您个人权益的行为，我们承担相应的责任。</strong></p>
                          <p>2.	我们不会非法出售、非法向他人提供您的信息；我们不会将您的该等信息提供给任何第三方，也不会用于任何其他目的和用途，但是以下情形除外：</p>
                          <p>(1)	经您事先同意，向第三方披露；</p>
                          <p>(2)	根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
                          <p>(3)	在我们提供服务时，可能将您的信息用于身份验证、客户服务、安全防范、诈骗监测、存档和备份等用途，以预防、发现、调查欺诈、危害安全、非法或违反与我们的协议、政策或规则的行为，以保护您、其他用户、我们的关联公司、合作伙伴及其他受信任的第三方供应商、服务商、代理商及社会公众的合法权益，以确保我们向您提供的产品和服务的安全性；</p>
                          <p>(4)	我们与第三方合作向您提供本产品平台的相关服务或其他网络服务，且该等第三方同意承担与我们同等的保护用户隐私的责任；</p>
                          <p>(5)	其他根据法律、法规或者政策应进行的披露。</p>
                          <p>3.	我们仅会在以下情形下，公开披露您的个人信息：</p>
                          <p>(1)	获得您明确同意后；</p>
                          <p>(2)	基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>
                          <p>4.	共享、转让、公开披露个人信息时事先征得授权同意的例外：</p>
                          <p>(1)	与个人信息控制者履行法律法规规定的义务相关的；</p>
                          <p>(2)	与国家安全、国防安全直接相关的；</p>
                          <p>(3)	与公共安全、公共卫生、重大公共利益直接相关的；</p>
                          <p>(4)	与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
                          <p>(5)	出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
                          <p>(6)	个人信息主体自行向社会公众公开的个人信息；</p>
                          <p>(7)	从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
                          <p><strong>5.	根据法律规定，共享、转让、披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理无需另行征得您的同意。</strong></p>


                          <h3>五、您如何管理自己的信息及账号注销</h3>
                          <p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
                          <p>1.	查询权</p>
                          <p>您有权访问您的个人信息，法律法规规定的情形例外除外。</p>
                          <p>您可以通过“本产品App-家长中心”查询或编辑您的账户中的个人资料等信息。</p>
                          <p>2.	更正权</p>
                          <p>当您发现我们处理关于您的个人信息有错误时，您可以通过“官网->个人中心”查询到您的信息进行修改。</p>
                          <p>3.	删除权</p>
                          <p>以下情形下，您可以向我们提出删除个人信息的请求：</p>
                          <p>(1)	如果我们处理个人信息的行为违反法律法规；</p>
                          <p>(2)	如果我们收集、使用您的个人信息，却未征得您的同意；</p>
                          <p>(3)	如果我们处理个人信息的行为违反了与您的约定；</p>
                          <p>(4)	如果您不再使用我们的产品或服务，或您注销了账号；</p>
                          <p>(5)	如果我们不再为您提供产品或服务。</p>
                          <p>当您决定删除某项或某几项信息时，发送邮件至xiaoqiang@cutterman.cn。</p>
                          <p>4.	撤销权</p>
                          <p>(1)	对于您个人主动提供的信息，您可以在您的“官网-个人中心”个人账户中进行撤销您的个人信息；</p>
                          <p>(2)	对于您授权给我们的信息，您可以在“手机-设置-隐私-权限管理”中进行撤销。<strong>请您注意，不同的设备中，路径可能有所不同，具体参考您的设备及系统开发方的说明和指引。</strong></p>
                          <p>当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。</p>
                          <p>5.	注销权</p>
                          <p>如果您决定停止使用本产品的，则您可以通过联系本产品的在线客服（官网提供的官方客服渠道）对您的账号进行注销。需要人工处理的，我们将在15个工作日内完成核查和处理。在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。<strong>注销账号之后此账号内的数据无法恢复；本产品没有义务向用户返还任何数据。注销行为操作后无法撤销，请用户谨慎申请。</strong></p>
                          <p>6.	响应您的上述请求</p>
                          <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
                          <p>我们将在30日内或法律法规规定的期限内作出答复。如您不满意，还可以通过以下途径投诉：发送邮件至xiaoqiang@cutterman.cn或通过官方反馈渠道联系我们。</p>
                          <p>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
                          <p><strong>在以下情形中，按照法律法规的要求，我们将无法响应您的上述请求：</strong></p>
                          <p>(1)	与个人信息控制者履行法律法规规定的义务相关的；</p>
                          <p>(2)	 与国家安全、国防安全直接相关的；</p>
                          <p>(3)	与公共安全、公共卫生、重大公共利益直接相关的；</p>
                          <p>(4)	与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
                          <p>(5)	个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
                          <p>(6)	出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
                          <p>(7)	响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</p>
                          <p>(8)	涉及商业秘密的。</p>


                          <h3>六、我们如何存储您的信息</h3>
                          <p>我们在中华人民共和国境内运营中收集和产生的个人信息，原则上存储在中国境内，并按照中国中华人民共和国法律法规、部门规章等规定的存储期限存储您的个人信息，存储期限为您使用本产品的期限或者向本产品发出删除您的个人信息之前，当您要求删除该存储信息或者决定停止使用本产品注销账号之时，我们将及时删除您的个人信息。同时只会在达成本隐私政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年；就服务所涉及的用户行为日志，我们将进行匿名化处理。判断前述期限的标准包括：</p>
                          <p>（1）完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉；</p>
                          <p>（2）保证平台为您提供服务的安全和质量；</p>
                          <p>（3）您是否同意更长的留存期间；</p>
                          <p>（4）是否存在保留期限的其他特别约定。</p>
                          <p>在您的个人信息超出保留期间后，公司会根据适用法律的要求删除您的个人信息，或使其匿名化处理（如您为未成年人，在您的个人信息超出保留期间后，公司会按照相关法律法规要求对您的个人信息进行相应处理）。如因特殊情形无法按照相关要求删除的，公司将对该部分事项向您进行说明。</p>

                          <h3>七、我们如何保护您的信息</h3>
                          <p>1.	我们非常重视您的个人信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的个人信息，并尽最大合理努力使您的个人信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您个人信息的员工或外包人员也采取了严格管理，包括但不限于采取信息访问权限控制、与接触个人信息的人员签署保密协议、监控该等人员的操作情况等措施。</p>
                          <p><strong>2.	尽管有上述第（1）款的约定，但是请您理解并明白，由于存在各种各样无法预知或现有技术无法防御的恶意手段，即便我们已经尽力采取必要的保护措施，您的信息仍有可能被泄露、毁损或灭失。如您发现您的账号、密码因任何原因已经或者将要泄露时，您应当立即跟我们联系，以便我们可以及时采取应对措施防止或减少您的相关损失。</strong></p>
                          <p>3.	如果我们发生企业合并、分立等情形的，则您的信息将由届时存续的企业主体继续履行保护义务，并由我们以公告、短信或其他书面方式通知您；如果我们的产品、服务停止运营的，则我们将及时停止继续收集您的信息，并以公告、短信等方式通知您，届时我们将对您的信息进行及时删除处理。</p>

                          <h3>八、未成年人保护</h3>
                          <p><strong>我们重视未成年人的个人信息保护，如您为十八周岁以下的未成年人，请在您的监护人指导下仔细阅读本隐私政策，并在征得您的监护人同意的前提下使用我们的服务及提交您的个人信息。如您的监护人不同意本隐私政策，您应立即停止使用本产品的服务并拒绝提供个人信息。</strong></p>
                          <p><strong>如果您是未满十四周岁的未成年人，请您通知您的监护人共同阅读并接受我们的《服务协议》并在您使用本产品服务、提交个人信息之前，寻求您的监护人同意和指导。</strong></p>
                          <p><strong>对于监护人同意而收集的儿童个人信息，我们仅会在法律法规允许、监护人明确同意或保护儿童用户的范围内使用或披露该信息。对于未经监护人同意而儿童用户提供的个人信息，在接到其监护人的通知后，我们会尽快删除相关信息。</strong></p>

                          <h3>九、本政策的修订</h3>
                          <p>我们可不定期修改本隐私政策，变更后的隐私政策将在修订生效前通过本产品平台公告或以其他适当方式通知您。该等情况下，若您继续使用我们的服务，即表示同意受经修订的隐私政策的约束。</p>

                          <h3>十、争议管辖</h3>
                          <p>1.	本隐私政策的签订、生效、履行、争议的解决均适用中华人民共和国法律。</p>
                          <p>2.	有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交公司所在地有管辖权的法院诉讼解决。</p>

                          <h3>十一、联系我们</h3>
                          <p>如您有任何疑问或投诉、举报，您可以通过下述方式联系我们，我们将在15日内回复您的请求。</p>
                          <p>北京灵动无线网络科技有限公司</p>
                          <p>邮箱：xiaoqiang@cutterman.cn</p>

                        </div>
                    </div>
                </div>
                <!--end col-->
            </div>
            <!--end row-->
        </div>
        <!--end container-->
    </section>
    <!--end section-->
    <!-- End Privacy -->
    <!--end section-->
    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" v-scroll-to="'#topnav'">
        <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
</div>
</template>
